import { useEffect, useState } from "react";
import { Button, ConfigProvider, Drawer, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
const { Header, Content } = Layout;
import {
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import ExamSidebar from "../components/shared/ExamSidebar";
import { useDispatch } from "react-redux";
import AdminSidebar from "../components/shared/AdminSidebar";
import { deleteUser } from "../redux/slices/authSlice";
const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const [hidden, setHidden] = useState(window.innerWidth < 640);
  const [drawerOpen, setDrawerOpen] = useState(false); // New state for mobile sidebar drawer
  const dispatch = useDispatch();
  const [hostname, setHostname] = useState("");
  useEffect(() => {
    const handleResize = () => {
      setCollapsed(window.innerWidth < 768);
      setHidden(window.innerWidth < 640);
      if (window.innerWidth >= 640) {
        setDrawerOpen(false); // Close drawer when resizing to a bigger screen
      }
    };

    if (typeof window !== "undefined") {
      setHostname(window.location.hostname);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ConfigProvider theme={{}}>
      <Layout>
        <Header className="pl-0 pr-10 bg-background text-text_clr flex items-center justify-between border-b">
          <div className="flex items-center">
            {/* Show hamburger button only when sidebar is hidden */}
            {hidden ? (
              <div className="w-[80px] flex justify-center">
                <Button
                  type="text"
                  icon={<MenuOutlined />}
                  onClick={() => setDrawerOpen(true)}
                />
              </div>
            ) : (
              <div className="w-[80px] flex justify-center">
                <Button
                  type="text"
                  icon={collapsed ? <MenuOutlined /> : <MenuOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                />
              </div>
            )}
            <div className="grid items-center h-16 font-semibold">
              <a href={`/`} className="text-5xl text-center text-slate-400">
                G
              </a>
            </div>
          </div>
          <Button type="primary" danger onClick={() => dispatch(deleteUser())}>
            Logout
          </Button>
        </Header>
        <Layout className="h-[calc(100vh-64px)] relative overflow-hidden">
          {/* Sidebar for larger screens */}
          {!hidden && (
            <div className="h-full sticky left-0 top-0">
              <AdminSidebar collapsed={collapsed} />
            </div>
          )}

          {/* Sidebar Drawer for mobile screens */}
          <Drawer
            title="Menu"
            placement="left"
            closable
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            width={250}
          >
            <AdminSidebar collapsed={false} />
          </Drawer>

          <Layout className="overflow-y-auto bg-white">
            <Content className="px-8 py-5 bg-background text-text_clr">
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default AdminLayout;
